import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { array, boolean, nullable, object, string } from "../../../types/_types";

export const Comment = FirestoreDocument.merge(FirestoreLifecycle).extend({
	text: string(),
	channels: array(string()),
	replyTo: nullable(string()),
	seenByUserIds: array(string()),
	sender: FirestoreDocument.extend({
		img: nullable(string()),
		name: string(),
	}),
	attachments: array(
		object({
			url: string(),
			name: string(),
		}),
	),
	needsAttention: boolean(),
	producerId: nullable(string()),
});

export const CommentRef = Comment.pick({
	id: true,
	ref: true,
	text: true,
	sender: true,
	created: true,
});
